module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\n:host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/utils/ui-elements/ui-form-group/ui-form-group.less
// module id = 1101
// module chunks = 3